import "react-app-polyfill/ie11";
import React from "react";
import "@babel/polyfill";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

import App from "./App";

import * as serviceWorker from "./serviceWorker";

const app = (
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </BrowserRouter>
);

ReactDOM.render(app, document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
